import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { filter, map, takeUntil } from 'rxjs/operators';
import { DocumentService } from '../../../../documents/document.service';
import { Document } from '../../../../shared/sdk';

@Component({
  selector: 'app-document-view-document',
  templateUrl: './document-view-document.component.html',
  styleUrls: ['./document-view-document.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocumentViewDocumentComponent implements OnInit, OnDestroy {
  @Input() document: Document;
  @Input() locale: string;
  @Input() paymentQR: boolean;
  @Input() paymentQRVisible: boolean;
  typeName: Observable<string>;
  private onDestroy = new Subject<void>();

  constructor(private documentService: DocumentService) {}

  lod(data: any, field: string, l10nField?: string): string {
    return this.documentService.getLocalizedOrDefault(
      data,
      this.locale,
      field,
      l10nField,
    );
  }

  ngOnDestroy(): void {
    this.onDestroy.next();
    this.onDestroy.complete();
  }

  ngOnInit() {
    this.typeName = this.documentService.documentTypes.pipe(
      filter((documentTypes) => !!documentTypes),
      map((documentTypes) => documentTypes[this.document.type].name),
      map((typeName) => typeName.slice(0, 1).toUpperCase() + typeName.slice(1)),
      takeUntil(this.onDestroy),
    );
  }
}
